module.exports = __webpack_public_path__ + "img/38.8adb1f45.png";